import React from 'react';
import { makeStyles, Select, MenuItem } from '@material-ui/core';
var useStyles = makeStyles(function () { return ({
    root: {
        fontSize: '12px'
    }
}); });
export function PageSizeSelector(_a) {
    var paginationState = _a.paginationState, onChange = _a.onChange;
    var classes = useStyles();
    return (React.createElement(Select, { className: classes.root, value: paginationState.pageSize, onChange: onChange },
        React.createElement(MenuItem, { value: 10 }, "10"),
        React.createElement(MenuItem, { value: 25 }, "25"),
        React.createElement(MenuItem, { value: 50 }, "50"),
        React.createElement(MenuItem, { value: 100 }, "100")));
}
//# sourceMappingURL=PageSizeSelector.js.map